var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Button, Form as UIForm } from 'semantic-ui-react';
import * as Authentication from '~/Api/Authentication';
import { useApi, useApiResult } from '~/ApiHooks';
import { useErrorHandler } from '~/ErrorHandler';
var ValidationError;
(function (ValidationError) {
    ValidationError[ValidationError["passwordsMissmatch"] = 0] = "passwordsMissmatch";
    ValidationError[ValidationError["passwordTooShort"] = 1] = "passwordTooShort";
    ValidationError[ValidationError["passwordTooBig"] = 2] = "passwordTooBig";
})(ValidationError || (ValidationError = {}));
var Form = function (_a) {
    var disabled = _a.disabled, error = _a.error, minLength = _a.minLength, values = _a.values, onChange = _a.onChange, onSubmit = _a.onSubmit;
    var submit = function (event) {
        event.preventDefault();
        if (event.currentTarget.reportValidity()) {
            onSubmit();
        }
    };
    return (<UIForm noValidate onSubmit={submit}>
			<p>Zvolte heslo alespoň {minLength} znaků dlouhé</p>

			<UIForm.Input fluid required disabled={disabled} error={error === ValidationError.passwordTooShort
            ? "Heslo mus\u00ED m\u00EDt alespo\u0148 ".concat(minLength, " znak\u016F")
            : error === ValidationError.passwordTooBig
                ? 'Heslo je moc dlouhé'
                : null} icon='lock' iconPosition='left' label='Heslo' type='password' onChange={function (event) {
            onChange(__assign(__assign({}, values), { password: event.target.value }));
        }}/>
			<UIForm.Input fluid required disabled={disabled} error={error === ValidationError.passwordsMissmatch ? "Hesla se neshoduj\u00ED, zkuste to pros\u00EDm znovu" : null} icon='lock' iconPosition='left' label='Heslo' type='password' onChange={function (event) {
            onChange(__assign(__assign({}, values), { passwordCheck: event.target.value }));
        }}/>

			<Button disabled={disabled} size='large'>
				Nastavit heslo
			</Button>
		</UIForm>);
};
export var Setup = function (_a) {
    var _b, _c;
    var _d = _a.minLength, minLength = _d === void 0 ? Authentication.PasswordMinLength : _d, token = _a.token, userId = _a.userId, onComplete = _a.onComplete;
    var passwordReset = useApiResult(new Authentication.PasswordResetRequest(token, userId), [token, userId])[0];
    var _e = React.useState({ password: '', passwordCheck: '' }), values = _e[0], setValues = _e[1];
    var _f = React.useState(null), validationError = _f[0], setValidationError = _f[1];
    var _g = useApi(), setup = _g[0], result = _g[1];
    var onError = useErrorHandler().onError;
    React.useEffect(function () {
        if (passwordReset.value !== null && !passwordReset.value.passwordReset.active) {
            onComplete();
        }
    }, [passwordReset]);
    var valuesChanged = function (values) {
        setValues(values);
        setValidationError(null);
    };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onError(null);
                    error = Array.from(values.password).length < minLength
                        ? ValidationError.passwordTooShort
                        : Authentication.isPasswordTooBig(values.password)
                            ? ValidationError.passwordTooBig
                            : values.password !== values.passwordCheck
                                ? ValidationError.passwordsMissmatch
                                : null;
                    setValidationError(error);
                    if (error !== null) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, setup(new Authentication.PasswordSetupRequest(token, userId, values.password))];
                case 1:
                    response = _a.sent();
                    if (response.value !== null) {
                        onComplete();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (!((_c = (_b = passwordReset.value) === null || _b === void 0 ? void 0 : _b.passwordReset.active) !== null && _c !== void 0 ? _c : false)) {
        return null;
    }
    return (<Form disabled={result.isLoading} error={validationError} minLength={minLength} values={values} onChange={valuesChanged} onSubmit={submit}/>);
};
Setup.displayName = 'PasswordSetup';
